import "../../css/components/Lineal.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Dynamic from "./Dynamic";
import Logger from "../utils/Logger";
import g from "../utils/globals";
import { bgColor } from "../utils/helpers";

const logger = new Logger(__filename);

class Lineal extends Component {
  componentDidMount = () => {
    bgColor(this.props);
    // uiColor
    const customContent = this.props.contents && this.props.contents.reverse().find(x => x.customProps && x.customProps.uiColor);
    if ((this.props.customProps && this.props.customProps.uiColor) || customContent) {
      document.body.setAttribute("data-ui", (customContent || this.props).customProps.uiColor);
    }
    // enhancement
    if (this.props.enhancement && !this.props.enhancement.Content) {
      if (this.props.enhancement.init) {
        try {
          this.props.enhancement.init(this);
          logger.log(`... enhancing content [${this.props.attrs.id}]`);
        } catch (error) {
          logger.error(`Enhancement error: ${this.props.attrs.id}`);
          logger.debug(error);
        }
      }
      if (this.props.enhancement[g.fileName] && this.props.enhancement[g.fileName].init) {
        try {
          this.props.enhancement[g.fileName].init();
          logger.log(`... enhancing content [${g.fileName}]`);
        } catch (error) {
          logger.error(`Enhancement error: ${g.fileName}`);
          logger.debug(error);
        }
      }
    }
  };
  render = () => {
    if (this.props.enhancement && this.props.enhancement.Content) {
      const Content = this.props.enhancement.Content;
      return (
        <div
          ref={el => {
            this.el = el;
          }}
          {...this.props.attrs}
        >
          <Content enhancement={this.props.enhancement} contents={this.props.contents} l10n={this.props.l10n} />
        </div>
      );
    }
    return (
      <div
        ref={el => {
          this.el = el;
        }}
        {...this.props.attrs}
      >
        {this.props.contents.map((m, index) => (
          <Dynamic key={index} {...m} root={this.props.root} customHTML={this.props.partialHTML ? this.props.customHTML : false} />
        ))}
      </div>
    );
  };
}

Lineal.propTypes = {
  attrs: PropTypes.object,
  contents: PropTypes.array,
};

export default Lineal;
